<template>
  <div>
    <br>
    <br>
    <div class="section py-0 px-5" v-if="afficherSlider">
      <vue-slider :min="rayonMin"
                  :max="rayonMax"
                  :interval="rayonInterval"
                  :clickable= false
                  v-model="rayon"
                  tooltip="always"
                  formatter="{value} km"
                  @drag-end="dragEnd"/>
    </div>
    <hr>
    <app-date/>
    <hr>
    <app-disponibilite/>
    <hr>
    <app-ajout-filtre/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { RAYON_MAX, RAYON_MIN, RAYON_INTERVAL } from '@/configuration/carteConf';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';
import vueSlider from 'vue-slider-component';
import gestionErreur from '@/services/general/gestionErreur';
import filtreDate from './date';
import filtreDisponibilite from './disponibilite';
import AjoutFiltre from './ajoutFiltre';

const Panier = createNamespacedHelpers('panier');
const Numerique = createNamespacedHelpers('venteNumerique');

export default {
  name: 'filtrePatrimoine',
  props: ['afficherSlider'],
  components: {
    vueSlider,
    appDate: filtreDate,
    appDisponibilite: filtreDisponibilite,
    appAjoutFiltre: AjoutFiltre,
  },
  data() {
    return {
      rayonMax: RAYON_MAX,
      rayonMin: RAYON_MIN,
      rayonInterval: RAYON_INTERVAL,
      valid: false,
    };
  },
  computed: {
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    ...Numerique.mapGetters({
      getAddress: 'address',
      getRayon: 'rayon',
    }),
    rayon: {
      get() {
        return this.getRayon;
      },
      set(value) {
        this.setFilterRayon(value);
      },
    },
  },
  methods: {
    ...Numerique.mapMutations({
      setFilterRayon: types.SET_FILTER_RAYON,
      setAffichageCercle: types.SET_AFFICHAGE_CERCLE,
    }),
    ...Numerique.mapActions({
      actionsRecuperationPanneaux: 'recuperationPanneaux',
    }),
    dragEnd() {
      if (this.address) {
        this.valid = true;
        this.setAffichageCercle(true);
        this.recherchePanneaux();
      }
    },
    recherchePanneaux() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsRecuperationPanneaux({ address: this.address,
        codeFace: this.codeFace,
        rayon: this.rayon,
        valid: this.valid,
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des panneaux numériques liée au filtre patrimoine', e);
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/filtres/filtrePatrimoine.vue